/**
 * @flow
 * @relayHash f1d89429002742320562bbf4409b12f4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type WMRightSectionResult_getLonewolfPersonalData$ref = any;
export type WMRightSectionQueryVariables = {|
  event_token: string,
  guest_token: string,
  quarter_id: number,
|};
export type WMRightSectionQueryResponse = {|
  +$fragmentRefs: WMRightSectionResult_getLonewolfPersonalData$ref
|};
export type WMRightSectionQuery = {|
  variables: WMRightSectionQueryVariables,
  response: WMRightSectionQueryResponse,
|};
*/


/*
query WMRightSectionQuery(
  $event_token: String!
  $guest_token: String!
  $quarter_id: Int!
) {
  ...WMRightSectionResult_getLonewolfPersonalData_17dKGk
}

fragment WMRightSectionResult_getLonewolfPersonalData_17dKGk on Query {
  getLonewolfPersonalData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id) {
    data {
      user {
        name
        points
        position
      }
      current_group_number
      current_bid
      current_pool
      last_group {
        group_number
        guests
        winning_players
        winning_money
      }
      winnings_by_group {
        group_number
        money
        user_won
      }
      next_groups {
        group_number
        players {
          name
          percentage
          picked
        }
      }
      total_page
      cumulative_total_page
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_token",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "guest_token",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "quarter_id",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "event_token",
    "variableName": "event_token"
  },
  {
    "kind": "Variable",
    "name": "guest_token",
    "variableName": "guest_token"
  },
  {
    "kind": "Variable",
    "name": "quarter_id",
    "variableName": "quarter_id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "group_number",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "WMRightSectionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "WMRightSectionResult_getLonewolfPersonalData",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "WMRightSectionQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getLonewolfPersonalData",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "lonewolfPersonalLeaderboardType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "lonewolfPersonalDataType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "lonewolfPositionsType",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "points",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "position",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "current_group_number",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "current_bid",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "current_pool",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "last_group",
                "storageKey": null,
                "args": null,
                "concreteType": "lonewolfLastGroupType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guests",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "winning_players",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "winning_money",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "winnings_by_group",
                "storageKey": null,
                "args": null,
                "concreteType": "lonewolfWinningsByGroupType",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "money",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "user_won",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "next_groups",
                "storageKey": null,
                "args": null,
                "concreteType": "lonewolfNextGroupType",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "players",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "lonewolfNextGroupPlayersType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "percentage",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "picked",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total_page",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cumulative_total_page",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "WMRightSectionQuery",
    "id": null,
    "text": "query WMRightSectionQuery(\n  $event_token: String!\n  $guest_token: String!\n  $quarter_id: Int!\n) {\n  ...WMRightSectionResult_getLonewolfPersonalData_17dKGk\n}\n\nfragment WMRightSectionResult_getLonewolfPersonalData_17dKGk on Query {\n  getLonewolfPersonalData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id) {\n    data {\n      user {\n        name\n        points\n        position\n      }\n      current_group_number\n      current_bid\n      current_pool\n      last_group {\n        group_number\n        guests\n        winning_players\n        winning_money\n      }\n      winnings_by_group {\n        group_number\n        money\n        user_won\n      }\n      next_groups {\n        group_number\n        players {\n          name\n          percentage\n          picked\n        }\n      }\n      total_page\n      cumulative_total_page\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0d528b76d1b30205c44bfcd0408fdd81';
module.exports = node;
